/*
* 组件数组 视图内容输出
* */

'use strict';
var React = require('react');
var compHelper = require('../Components/compHelper');

var Components = React.createClass({
  propTypes: {
    events: React.PropTypes.object.isRequired,
    components: React.PropTypes.array.isRequired
  },
  render: function () {
    var events = this.props.events;
    return (
      <div className='components'>
        {this.props.components.map(function (comp) {
          return compHelper.makeComp(comp, events);
        })}
      </div>
    );
  }
});

module.exports = Components;



// WEBPACK FOOTER //
// ./src/views/Page/Components.jsx